import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloLink } from 'apollo-link';
import { onError } from "apollo-link-error";


const errorLink = onError(({ networkError, graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`,
      )
    );
  }
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const httpLink = new HttpLink({
    uri: process.env.VUE_APP_GRAPHQL_HTTP || 'http://tradeinpool.com:4000/graphql',
})

const cache = new InMemoryCache()


const authMiddleware = new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    operation.setContext({
      headers: {
        authorization: localStorage.getItem('apollo-token') || null,
      }
    });
    return forward(operation);
  })



  const link = ApolloLink.from([
    authMiddleware,
    errorLink,
    httpLink,
  ]);


export const apolloClient = new ApolloClient({
    link: link,
    cache,
    // add the authorization to the headers
})
